export default __webpack_public_path__ + "static/assets/5a34c79b9ae9516dd7692a4c39d02801.svg";